import React from "react";
import { Container, Row, Col, Form, Button, Spinner, OverlayTrigger, Tooltip, Tabs, Tab, Dropdown, } from "react-bootstrap";
import { accountService } from "../../Common/Services/account";
import { Register as registersevice } from "../../Common/Services/Register";
import { confirmAlert } from "react-confirm-alert";
import { resolve, reject } from "q";
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { VendorSearch } from "../../Common/Components/VendorSearch";
import OutsideClickHandler from "react-outside-click-handler";
import { FiChevronDown } from "react-icons/fi";
import Calendar from 'react-calendar';
import { InfoTooltip } from "../../Common/Components/InfoTooltip";
import "react-calendar/dist/Calendar.css";
import "../Register/slideout.scss";
import { Hotel as hotel } from "../../Common/Services/Hotel";
import { SetupBankSync } from "../Accounting/BankSync/SetupBankSync";
import { PlaidSetup } from "../../Common/ThirdPartyServices/PlaidSetup";
import { ToastContainer, toast } from "react-toastify";
import { Utils } from "../../Common/Utilis";

var PlaidLink = require("react-plaid-link");
let localStorageUser: any;
export class CreditCardAccountSlideout extends React.Component<any, any> {
    private vendorSearch: any;
    private coaRef: any;
    private openingDateRef: any;
    private pageName = "CreditCardEntry";
    constructor(props: any) {
        super(props);
        this.vendorSearch = React.createRef();
        this.coaRef = React.createRef();
        this.openingDateRef = React.createRef();
        this.state = {
            isDiscardChanges: false,
            isSpinner: false,
            hotelName: this.props.hotelName,
            hotelValue: this.props.hidValue,
            vendorList: [],
            requestlist: { hotelID: 0, oprID: '-1', etype: 'CreditCardAccount', vid: 0, recordCount: 5 },
            coaList: [],
            selectedCOA: [],
            calendarOpened: false,
            calenderSelectDate: "",
            selectedStatus: { id: "", name: "" },
            formData: {
                uniqueno: 0, cardNo: "", cardNoWithencrypt: "", vendorID: -1, vendorName: "", vendorContract: "", coa: "",
                displayName: "", openingDate: "", status: "Active", hotelID: this.props.hidValue, isSearchable: "Yes", setDefault: "No",
            },
            errors: {
                cardNo: '',
                vendorName: '',
                vendorContract: '',
                coa: '',
                displayName: '',
                openingDate: '',
            },
            activeTab: props?.callFrom === "accountsPage" || props?.callFrom === "BankSync" ? "banksync" : "general",
            bankSyncOn: false,
            pullTransDays: "",
            isBankSyncDone: false,
            plaidConnectionStatus: "",
            bankSyncPerm: false,
            connectedAcctName: this.props?.accountName,
            isPlaidDone: false,
            accountOpeningDate: "",
            isBankSyncFeatureFlag: false,
            isPlaidProcessComplete: false
        }
        this.handleVendorChange = this.handleVendorChange.bind(this);
        this.openCalendar = this.openCalendar.bind(this);
        this.changeDate = this.changeDate.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        this.featureFlagForTenant();
        let requestlist = { ...this.state.requestlist };
        requestlist.hotelID = this.state.hotelValue;
        requestlist.etype = this.props.pageType;
        this.PlaidSetupDetails();
        PlaidSetup.IntegratePlaid1();
        this.getCOAList();
        this.vendorSearch.current.GetVendorTranlist(requestlist);
        if (this.props.actionType === "edit") {
            this.getCreditCardDetails();
        }
    }

    featureFlagForTenant = () => {
        let { isBankSyncFeatureFlag } = this.state;
        isBankSyncFeatureFlag = false;
        accountService.GetFeatureFlagForTenant()
            .then(async (result: any | null) => {
                if (result !== null) {
                    isBankSyncFeatureFlag = result.some((o: any) => o?.featureValue?.toString().toLowerCase() === "bank sync" && o?.featureStatus?.toString().toLowerCase() === "yes");
                }
                this.setState({ isBankSyncFeatureFlag });
            });
    }

    PlaidSetupDetails = () => {
        let request: any = {};
        request.hotelID = this.state.hotelValue; //ExistingFundingSource
        request.oprID = this.props.oprID;
        request.acctType = this.props?.actionType === "new" ? "" : "CC";
        accountService
            .PlaidSetupDetails(request)
            .then(async (result: any | null) => {
                if (result !== null) {
                    const isBankSetupDone = result?.isPlaidSetupForAccount;
                    const plaidConnectionStatus = result?.plaidConnectionStatus;
                    const bankSyncPerm = result?.bankSyncPerm;
                    const pullTransDays = result?.pullTransDays;
                    const accountOpeningDate = result?.accountOpeningDate;
                    this.setState({
                        isBankSyncDone: isBankSetupDone === "Setup Complete",
                        bankSyncOn: isBankSetupDone === "Setup Complete",
                        plaidConnectionStatus: plaidConnectionStatus,
                        bankSyncPerm: bankSyncPerm,
                        pullTransDays: pullTransDays,
                        isPlaidDone: false,
                        accountOpeningDate: accountOpeningDate,
                        activeTab: plaidConnectionStatus?.toLowerCase() === "reconnect" ? "banksync" : this.state.activeTab,
                    })
                }
            });
    }


    getCreditCardDetails() {
        this.setState({ isSpinner: true })
        let request: any = {};
        request.hotelID = this.state.hotelID;
        request.uniqueno = this.props.oprID;
        accountService.getCreditCardDetails(request)
            .then(async (result: any | null) => {
                if (result !== null) {
                    if (result.length > 0) {
                        let datee = new Date(result[0].openingDate);
                        let calenderYeare = datee.getFullYear().toString().substr(2, 4);
                        let calenderDatee = datee.getDate() > 9 ? datee.getDate() : 0 + "" + datee.getDate();
                        let calenderMonthe = datee.getMonth() + 1 > 9 ? datee.getMonth() + 1 : 0 + "" + (datee.getMonth() + 1);
                        let tempDatee = calenderMonthe + "/" + calenderDatee + "/" + calenderYeare;
                        result[0].openingDate = tempDatee;
                        this.setState({ calenderSelectDate: datee, formData: result[0] })
                        this.setState({ selectedCOA: [{ id: result[0].coa, label: result[0].coa }] });

                        let vendorSelected: any = [];
                        let vendorItem: any = {};
                        vendorItem.id = result[0].vendorID;
                        vendorItem.accountNo = "";
                        vendorItem.aid = 0;
                        vendorItem.salestax = "";
                        vendorItem.vendorName = result[0].vendorName;
                        vendorSelected.push(vendorItem);
                        this.vendorSearch?.current.handleSelectFromParent(vendorSelected);
                        this.setState({ isSpinner: false })
                    } else {
                        this.setState({ isSpinner: false })
                    }
                }
            });
    }

    pageClose(mode) {
        if (this.state.isPlaidProcessComplete)
            mode = 1;
        this.props.hideCreditCardSlideOut(mode);
    }
    closeSlideout = () => {
        if (this.state.isDiscardChanges) {
            confirmAlert({
                title: "Unsaved confirmation",
                message:
                    "You have unsaved changes on this page. Do you want to leave this page and discard your changes?",
                buttons: [
                    {
                        label: "Yes",
                        onClick: () => this.pageClose(0),
                    },
                    {
                        label: "No",
                        onClick: () => reject(),
                    },
                ],
                closeOnEscape: false,
                closeOnClickOutside: false,
            });
        } else {
            let isRefresh = 0;
            if (this.state.isPlaidProcessComplete)
                isRefresh = 1;
            this.props.hideCreditCardSlideOut(isRefresh);
        }
    }

    // Vendor List
    GetVendorTranlist = (requestlist: any) => {
        registersevice.GetVendorTranlist(requestlist)
            .then(async (result: any | null) => {
                if (result !== null) {
                    this.setState({ vendorList: result })
                }
                resolve();
            })
            .catch((error) => {
                reject();
            });
    };
    updateVendorList = (result: any) => {
        this.setState({ vendorList: [] }, () => {
            this.setState({ vendorList: result })
        })
    }
    handleVendorChange = (e: any) => {
        let errors = { ...this.state.errors };
        let formData = { ...this.state.formData };
        if (e.length > 0) {
            errors.vendorName = "";
            errors.vendorContract = "";
            formData.vendorID = e[0].vid;
            formData.vendorName = e[0].vendorName;
            formData.vendorContract = e[0].accountNo;
        } else {
            formData.vendorName = "";
            formData.vendorContract = "";
        }
        this.setState({ errors, formData, isDiscardChanges: true });
    }

    addContractPermission = (value) => { }
    // Get COA list
    getCOAList() {
        let request: any = {};
        request.hotelID = this.state.hotelID;
        accountService.COADetails(request)
            .then(async (result: any | null) => {
                if (result !== null) {
                    let coaArray: any = [];
                    result.forEach(element => {
                        let coalistdup: any = {};
                        coalistdup.id = element.coa;
                        coalistdup.label = element.coaName;
                        coaArray.push(coalistdup);
                    })
                    this.setState({ coaList: coaArray });
                }
            });
    }
    keyDown(event) {
        if ((event.keyCode === 8 || event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39)
            || (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) { }
        else {
            event.preventDefault()
        }
    }
    onCOAInputChange(val, refName) {
        if (val.trim().length > 5) {
            let currentVal = val.slice(0, 5);
            refName.current.inputNode.value = currentVal;
            refName.current.state.text = currentVal;
            val = currentVal;
        }
        let errors = this.state.errors;
        let formData = { ...this.state.formData };
        errors.coa = val.trim().length === 0 ? 'COA can not be blank.' : '';
        if (!isNaN(val)) {
            if (val.trim().length === 5) {
                formData.coa = val.trim();
                this.setState({ selectedCOA: [{ id: val, label: val }] });
            } else {
                errors.coa = 'COA should be five digits.';
            }
        }
        this.setState({ errors, formData, selectedCOA: [], isDiscardChanges: true });
    }

    // Calender
    changeDate = (datee: any) => {
        let formData = { ...this.state.formData };
        let errors = this.state.errors;
        let calenderYeare = datee.getFullYear().toString().substr(2, 4);
        let calenderDatee = datee.getDate() > 9 ? datee.getDate() : 0 + "" + datee.getDate();
        let calenderMonthe = datee.getMonth() + 1 > 9 ? datee.getMonth() + 1 : 0 + "" + (datee.getMonth() + 1);
        let tempDatee = calenderMonthe + "/" + calenderDatee + "/" + calenderYeare;


        formData.openingDate = tempDatee;
        errors.openingDate = tempDatee.trim().length === 0 ? 'Opening Date can not be blank.' : '';
        this.setState({
            errors,
            formData,
            calenderSelectDate: datee,
            calendarOpened: false,
            isDiscardChanges: true,
        });
    };
    openCalendar = () => {
        this.setState({ calendarOpened: true });
    };
    calenderHide = () => {
        this.setState({ calendarOpened: false });
    };



    handleChange = (event) => {
        const { name, value } = event.target;
        let errors = this.state.errors;
        let formData = { ...this.state.formData };
        switch (name) {
            case 'cardNo':
                errors.cardNo = value.trim().length === 0 ? 'Card Number can not be blank.' : '';
                if (value.length <= 50) {
                    formData.cardNo = value;
                }
                break;
            case 'vendorName':
                errors.vendorName = value.trim().length === 0 ? 'Card Vendor can not be blank.' : '';
                formData.vendorName = value;
                break;
            case 'vendorContract':
                errors.vendorContract = value.trim().length === 0 ? '' : '';
                formData.vendorContract = value;
                break;
            case 'coa':
                errors.coa = value.trim().length === 0 ? 'COA can not be blank.' : '';
                if (!isNaN(value)) {
                    if (value.trim().length <= 5) {
                        formData.coa = value.trim();
                    }
                }
                break;
            case 'displayName':
                errors.displayName = value.trim().length === 0 ? 'Please enter the displayName.' : '';
                if (value.length <= 10) {
                    formData.displayName = value;
                }
                break;
            case 'openingDate':
                errors.openingDate = value.trim().length === 0 ? 'Opening Date can not be blank.' : '';
                formData.openingDate = value;
                break;
            case 'status':
                formData.status = event.target.checked ? "Active" : "Inactive";
                break;
            case 'searchable':
                //debugger;
                formData.isSearchable = event.target.checked ? "Yes" : "No";
                break;
            case "primary":
                formData.setDefault = event.target.checked ? "Yes" : "No";
                break;
            }
        this.setState({ errors, formData, isDiscardChanges: true });
    }

    isFormValidate() {
        let errors = this.state.errors;
        let formData = { ...this.state.formData };
        let isForm = true;
        if (formData.cardNo.trim().length === 0) {
            errors.cardNo = 'Please enter Card Number.';
            isForm = false;
        }
        if (formData.vendorName.trim().length === 0) {
            errors.vendorName = 'Please enter valid Card Vendor.';
            isForm = false;
        }
        if (formData.vendorContract.trim().length === 0) {
            errors.vendorContract = '';
            isForm = false;
        }
        if (formData.coa.trim().length === 0) {
            errors.coa = 'COA can not be blank.';
            isForm = false;
        } else if (formData.coa.trim().length !== 5) {
            errors.coa = 'COA should be five digits.';
            isForm = false;
        }
        if (formData.displayName.trim().length === 0) {
            errors.displayName = 'Please enter the displayName.';
            isForm = false;
        }
        if (formData.openingDate.trim().length === 0) {
            errors.openingDate = 'Opening Date can not be blank.';
            isForm = false;
        }
        if (formData.status === "") {
            errors.status = 'Please select Active/Inactive Status';
            isForm = false;
        }
        if (formData.isSearchable === "") {
            errors.status = 'Please select Active/Inactive CC accounts searchable';
            isForm = false;
        }

        this.setState({ errors });
        if (isForm === true) {
            this.setState({ istabDisabled: false })
            return true;
        } else {
            return false;
        }
    }
    saveCardDetails = () => {
        if (this.isFormValidate()) {
            this.checkPrimaryAccount();
        }
    }

    checkPrimaryAccount() {
        let formData = { ...this.state.formData };
        if (formData.setDefault === "Yes") {
            this.isprimaryAccountExist(formData);
        } else {
            this.saveCreditCardDetails();
        }
    }

    isprimaryAccountExist(formData: any) {
        let request: any = {};
        request.hotelID = formData.hotelID;
        request.cardUniqueNo = formData.uniqueno;
        accountService
            .IsPrimaryAccExistsForCC(request)
            .then(async (result: any | null) => {
                if (result === "Yes") {
                    confirmAlert({
                        title: "Primary account confirmation",
                        message:
                            "A Primary Account already exists for this entity. Selecting this account as Primary will convert the other account to non-primary. Would you like to continue?",
                        //NW19887//"There is already one primary account exist for this Property, making this as primary will make existing account to non-primary. Would you like to continue?",
                        buttons: [
                            {
                                label: "Yes",
                                onClick: () => this.saveCreditCardDetails(),
                            },
                            {
                                label: "No",
                                onClick: () => reject(), // this.nonPrimaryACDetails(formData),
                            },
                        ],
                        closeOnEscape: false,
                        closeOnClickOutside: false,
                    });
                } else {
                    this.saveCreditCardDetails();
                }
                resolve();
            })
            .catch((error) => {
                reject();
            });
    }

    nonPrimaryACDetails(formData: any) {
        formData.setDefault = "No";
        this.saveCreditCardDetails();
    }

    saveCreditCardDetails = () => {
        this.setState({ isSpinner: true })
        let formData = { ...this.state.formData };
        accountService.SaveCreditCardDetails(formData)
            .then(async (result: any | null) => {
                if (result !== null) {
                    if (result.saveStatus === "Success") {
                        toast.success(result.message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            containerId: "CCDetailsSlideout",
                        });
                        this.setState({ isSpinner: false })
                        setTimeout(() => {
                            this.pageClose(1);
                        }, 2000);

                    }
                    else {
                        this.setState({ isSpinner: false })
                        Utils.toastError(result.message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            containerId: "CCDetailsSlideout",
                        });
                    }
                }
                resolve();
            })
            .catch((error) => {
                this.setState({ isSpinner: false })
                reject();
            });
    }
    
    handleDatePicker = (event: any, refName: any) => {
        this.setState({ calendarOpened: true });
        refName.current.focus();
    }
    handleTabSelect = (eventKey: any) => {
        if (this.props.actionType === "edit") {
            if (this.state.isDiscardChanges) {
                confirmAlert({
                    title: "Unsaved confirmation",
                    message:
                        "You have unsaved changes on this page. Do you want to save this page changes?",
                    buttons: [
                        {
                            label: "Yes",
                            onClick: () => this.saveCardDetails(),
                        },
                        {
                            label: "No",
                            onClick: () => reject(),
                        },
                    ],
                    closeOnEscape: false,
                    closeOnClickOutside: false,
                });
            } else {
                this.setState({ activeTab: eventKey });
            }
        } else {
            if (this.isFormValidate()) {
                this.setState({ activeTab: eventKey });
            }
        }
    };

    render() {
        const { errors } = this.state;
        return (
            <div className="transaction-slideout bankAccount-setting pos-fxd index-1000">
                {/* <ToastContainer
                    autoClose={3000}
                    containerId={"CCDetailsSlideout"}
                    enableMultiContainer
                /> */}
                <div className="d-flex">
                    <div className="back-drop" onClick={() => { this.closeSlideout() }}></div>
                    <Container fluid className="body-sec">
                        <div className="page-heading d-flex">
                            <div className="hid-set d-flex align-items-center">
                                {this.state.hotelName}
                            </div>
                            <div className="mr-auto d-flex align-items-center">
                                {this.state.activeTab === "banksync" ? this.props.accDisplayName : "Credit Card Account"}
                            </div>
                            <div className="action-group d-flex">
                                <button type="button" className="btn wht-bg cross" onClick={() => { this.closeSlideout() }}>
                                    <svg width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                                            fill="#84888C" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div className="bank-account-setting">
                            <Tabs
                                id="bank-account-setting"
                                activeKey={this.state.activeTab}
                                onSelect={this.handleTabSelect}
                            >
                                <Tab eventKey="general" title="General">
                                    <div className="form-section mr-28">
                                        <Form.Group as={Row} className={errors.cardNo.length > 0 ? "mb-3 error" : "mb-3"} controlId="cardNo">
                                            <Form.Label column sm="3">Card Number</Form.Label>
                                            <Col sm="4">
                                                <Form.Control placeholder="Enter card number"
                                                    autoComplete='off'
                                                    type="text" id="cardNo" name='cardNo'
                                                    value={this.state.formData.cardNo}
                                                    onChange={this.handleChange}
                                                />
                                                {errors.cardNo.length > 0 &&
                                                    <span className='error'>{errors.cardNo}</span>
                                                }
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className={errors.vendorName.length > 0 ? "mb-3 error" : "mb-3"} controlId="vendorName">
                                            <Form.Label column sm="3">Card Vendor</Form.Label>
                                            <Col className="pos-unset" sm="4">
                                                <VendorSearch
                                                    ref={this.vendorSearch}
                                                    updateVendorList={this.updateVendorList}
                                                    HID={this.state.hotelValue}
                                                    handleVendorChange={this.handleVendorChange}
                                                    pageName={this.pageName}
                                                    addContractPermission={this.addContractPermission}
                                                />
                                                {errors.vendorName.length > 0 &&
                                                    <span className='error'>{errors.vendorName}</span>
                                                }
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className={errors.vendorContract.length > 0 ? "mb-3 error" : "mb-3"} controlId="vendorContract">
                                            <Form.Label column sm="3">Account Number</Form.Label>
                                            <Col sm="4">
                                                <Form.Control plaintext readOnly placeholder="Enter Account Number"
                                                    autoComplete='off'
                                                    type="text" id="vendorContract" name='vendorContract'
                                                    value={this.state.formData.vendorContract}
                                                />
                                                {errors.vendorContract.length > 0 &&
                                                    <span className='error'>{errors.vendorContract}</span>
                                                }
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className={errors.coa.length > 0 ? "mb-3 error" : "mb-3"} controlId="coa">
                                            <Form.Label column sm="3">
                                                COA
                                                <OverlayTrigger placement="bottom" delay={{ show: 250, hide: 400 }}
                                                    overlay={
                                                        <Tooltip id={"tooltip-openingA/CBalance"}>
                                                            Please add new COA for the Account as COA number can not be selected from the existing COA's list
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span><InfoTooltip />{" "}</span>
                                                </OverlayTrigger>
                                            </Form.Label>
                                            <Col sm="4">

                                                <Typeahead

                                                    key="id"
                                                    id="coa"
                                                    ref={this.coaRef}
                                                    inputProps={{
                                                        type: 'number',
                                                    }}
                                                    onInputChange={input => this.onCOAInputChange(input, this.coaRef)}
                                                    onKeyDown={this.keyDown}
                                                    options={this.state.coaList}
                                                    placeholder={"Enter COA"}
                                                    selected={this.state.selectedCOA}
                                                    renderMenu={(results: any, menuProps) => (
                                                        <Menu {...menuProps}>
                                                            {results.map((result: any, index: any) => (
                                                                <>
                                                                    {result.label !== "" && (
                                                                        <MenuItem option={result} position={index}>
                                                                            <EllipsisWithTooltip placement="bottom">{result.label}</EllipsisWithTooltip>
                                                                        </MenuItem>
                                                                    )}
                                                                    {result.label === "" && (
                                                                        <MenuItem className="load-more" option={result} position={index}>
                                                                            Load More
                                                                        </MenuItem>
                                                                    )}


                                                                </>
                                                            ))}
                                                        </Menu>
                                                    )}
                                                />


                                                {errors.coa.length > 0 &&
                                                    <span className='error'>{errors.coa}</span>
                                                }
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className={errors.displayName.length > 0 ? "mb-3 error" : "mb-3"} controlId="displayName">
                                            <Form.Label column sm="3">Nickname</Form.Label>
                                            <Col sm="4">
                                                <Form.Control placeholder="Enter Nickname"
                                                    autoComplete='off'
                                                    type="text" id="displayName" name='displayName'
                                                    value={this.state.formData.displayName}
                                                    onChange={this.handleChange}
                                                />
                                                {errors.displayName.length > 0 &&
                                                    <span className='error'>{errors.displayName}</span>
                                                }
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-3" controlId="primaryAccount-custom-switch">
                                            <Form.Label column sm="3">
                                                Primary Account
                                                <OverlayTrigger placement="bottom" delay={{ show: 250, hide: 400 }}
                                                    overlay={
                                                        <Tooltip id={"tooltip-openingA/CBalance"}>
                                                            Each location must have one primary account. This account will be automatically used as the default payment method for all credit card transactions.
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span>
                                                        <InfoTooltip />{" "}
                                                    </span>
                                                </OverlayTrigger>
                                            </Form.Label>
                                            <Col sm="3">
                                                <Form.Check type="switch" id="primaryAccount" label="" name="primary"
                                                    // disabled={this.isPermission()}
                                                    checked={ this.state.formData.setDefault === "Yes" ? true : false }
                                                    onChange={this.handleChange}
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className={errors.openingDate.length > 0 ? "mb-3 error" : "mb-3"} controlId="openingDatee">
                                            <Form.Label column sm="3">Opening Date</Form.Label>
                                            <Col md="3">
                                                <div className="calender-picker input-form-calender">
                                                    <Form.Control placeholder="Select Opening Date"
                                                        autoComplete='off'
                                                        type="text" id="openingDate" name='openingDate'
                                                        value={this.state.formData.openingDate}
                                                        ref={this.openingDateRef}
                                                        onClick={() => this.openCalendar()}
                                                    />
                                                    {this.state.calendarOpened
                                                        ? <OutsideClickHandler
                                                            onOutsideClick={this.calenderHide}
                                                        >
                                                            <div className="calender">
                                                                <Calendar
                                                                    calendarType={"US"}
                                                                    onChange={this.changeDate}
                                                                    value={this.state.calenderSelectDate} />
                                                            </div>
                                                        </OutsideClickHandler>
                                                        : null}
                                                    <span className="calender-icon">
                                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0)">
                                                                <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z" />
                                                                <g filter="url(#filter0_d)">
                                                                    <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z" />
                                                                </g>
                                                            </g>
                                                            <defs>
                                                                <filter id="filter0_d" x="-1.75" y="1.5" width="21.5" height="23" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                                                                    <feOffset dy="4" />
                                                                    <feGaussianBlur stdDeviation="2" />
                                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                                                                </filter>
                                                                <clipPath id="clip0">
                                                                    <rect width="18" height="18" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </span>
                                                    <span className="chevron-down" onClick={(event: any) => this.handleDatePicker(event, this.openingDateRef)}>
                                                        <FiChevronDown />
                                                    </span>
                                                </div>
                                                {errors.openingDate.length > 0 &&
                                                    <span className='error'>{errors.openingDate}</span>
                                                }
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className={"mb-3"} controlId="statuss">
                                            <Form.Label column sm="3">Active</Form.Label>
                                            <Col sm="4">
                                                <Form.Check type="switch" id="status" label="" name="status"
                                                    checked={this.state.formData.status === "Active" ? true : false} onChange={this.handleChange} />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className={"mb-3"} controlId="searchable">
                                            <Form.Label column sm="3">Searchable</Form.Label>
                                            <Col sm="4">
                                                <Form.Check type="switch" id="searchable" label="" name="searchable"
                                                    checked={this.state.formData.isSearchable === "Yes" ? true : false} onChange={this.handleChange} />
                                            </Col>
                                        </Form.Group>
                                    </div>
                                </Tab>
                                {/* {this.state.bankSyncPerm && this.state.isBankSyncFeatureFlag && this.props?.actionType !== "new" && this.state.formData.status?.toString().toLowerCase() === "active" && (
                                    <Tab eventKey="banksync" title="Bank Sync" disabled={this.state.actionType === "new"}>
                                        <div className="BankSyncTab">
                                            <div className="body-section">
                                                <div className="form-section-banksync align-item-center d-flex flex-column">
                                                    <Form.Group className="d-flex align-item-center" controlId="bankSyncToggle">
                                                        <Form.Label className="toggleLabelB">
                                                            Bank Sync
                                                        </Form.Label>
                                                        <Form.Check
                                                            type="switch"
                                                            id="banksync"
                                                            label=""
                                                            className="bankSyncToggle"
                                                            checked={this.state.bankSyncOn}
                                                            onChange={(e: any) => { this.changeBankSyncOn(e.currentTarget.checked) }}
                                                        />
                                                    </Form.Group>
                                                </div>

                                                <div className="bank-tab">
                                                    <div className="body-section-bank-sync">
                                                        {!this.state.bankSyncOn && !this.state.isSpinner && (
                                                            <>
                                                                <div className="circleBankSection d-flex align-items-center justify-content-center">
                                                                    <div className="circle-BankFeed d-flex align-items-center justify-content-center">
                                                                        <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <g clip-path="url(#clip0_1314_21405)">
                                                                                <path d="M49.9999 99.9998C77.6141 99.9998 99.9998 77.6141 99.9998 49.9999C99.9998 22.3857 77.6141 0 49.9999 0C22.3857 0 0 22.3857 0 49.9999C0 77.6141 22.3857 99.9998 49.9999 99.9998Z" fill="#F4F8FB" />
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M23.7832 55.3916H50.0175L36.9004 48.1396L23.7832 55.3916Z" fill="#E4E8EB" />
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M29.8553 64.5416C29.8553 61.8934 29.9568 59.3787 30.1389 57.1143H26.5487C26.7309 59.3788 26.8323 61.8934 26.8323 64.5416C26.8323 67.4348 26.7113 70.1688 26.4961 72.5911H30.1916C29.9763 70.1688 29.8553 67.435 29.8553 64.5416ZM46.9037 64.5416C46.9037 61.8934 47.0051 59.3787 47.1873 57.1143H43.597C43.7793 59.3788 43.8806 61.8934 43.8806 64.5416C43.8806 67.4348 43.7596 70.1688 43.5444 72.5911H47.2399C47.0248 70.1688 46.9037 67.435 46.9037 64.5416ZM38.3795 64.5417C38.3795 61.8935 38.481 59.3788 38.6631 57.1144H35.0729C35.255 59.3789 35.3565 61.8935 35.3565 64.5417C35.3565 67.435 35.2355 70.1689 35.0202 72.5912H38.7157C38.5005 70.1688 38.3795 67.435 38.3795 64.5417Z" fill="#E4E8EB" />
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M51.0684 57.8788C51.5048 57.8788 51.8607 57.5229 51.8607 57.0865V55.5433C51.8607 55.1069 51.5048 54.751 51.0684 54.751H22.6673C22.2309 54.751 21.875 55.1069 21.875 55.5433V57.0865C21.875 57.5229 22.2309 57.8788 22.6673 57.8788H51.0684ZM25.8185 71.8272H47.9173C48.4209 71.8272 48.8315 72.2378 48.8315 72.7414V75.0633C48.8315 75.5669 48.4208 75.9775 47.9173 75.9775H25.8185C25.3149 75.9775 24.9043 75.5669 24.9043 75.0633V72.7414C24.9042 72.2379 25.3149 71.8272 25.8185 71.8272Z" fill="#CAD0D7" />
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M22.7892 78.1257H50.9465C51.4501 78.1257 51.8607 77.7151 51.8607 77.2116V75.8907C51.8607 75.3872 51.4501 74.9766 50.9465 74.9766H22.7892C22.2856 74.9766 21.875 75.3872 21.875 75.8907V77.2116C21.875 77.715 22.2856 78.1257 22.7892 78.1257Z" fill="#A9B0BB" />
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M50.0474 29.1269H76.2817L63.1645 21.875L50.0474 29.1269Z" fill="#CAD0D7" />
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M56.1191 38.277C56.1191 35.6287 56.2205 33.114 56.4027 30.8496H52.8125C52.9947 33.1141 53.0961 35.6287 53.0961 38.277C53.0961 41.1702 52.975 43.9042 52.7598 46.3264H56.4553C56.2401 43.9042 56.1191 41.1702 56.1191 38.277ZM73.1675 38.277C73.1675 35.6287 73.2689 33.114 73.4511 30.8496H69.8609C70.0432 33.1141 70.1445 35.6287 70.1445 38.277C70.1445 41.1702 70.0235 43.9042 69.8083 46.3264H73.5038C73.2886 43.9042 73.1675 41.1702 73.1675 38.277ZM64.6433 38.2771C64.6433 35.6289 64.7448 33.1141 64.9269 30.8497H61.3367C61.5189 33.1143 61.6203 35.6289 61.6203 38.2771C61.6203 41.1703 61.4993 43.9043 61.2841 46.3266H64.9796C64.7643 43.9042 64.6433 41.1703 64.6433 38.2771Z" fill="#CAD0D7" />
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M77.3326 31.6143C77.769 31.6143 78.1249 31.2584 78.1249 30.822V29.2786C78.1249 28.8422 77.769 28.4863 77.3326 28.4863H48.9315C48.4951 28.4863 48.1392 28.8422 48.1392 29.2786V30.8219C48.1392 31.2583 48.4951 31.6142 48.9315 31.6142H77.3326V31.6143ZM52.0826 45.5627H74.1815C74.6849 45.5627 75.0957 45.9733 75.0957 46.4768V48.7988C75.0957 49.3023 74.6849 49.713 74.1815 49.713H52.0826C51.5791 49.713 51.1685 49.3023 51.1685 48.7988V46.4768C51.1685 45.9733 51.5791 45.5627 52.0826 45.5627Z" fill="#A9B0BB" />
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M49.0533 51.8611H77.2107C77.7142 51.8611 78.1249 51.4505 78.1249 50.9469V49.6261C78.1249 49.1225 77.7142 48.7119 77.2107 48.7119H49.0533C48.5498 48.7119 48.1392 49.1225 48.1392 49.6261V50.9469C48.1392 51.4504 48.5499 51.8611 49.0533 51.8611Z" fill="#636C77" />
                                                                                <path d="M56.1201 56.1265C59.5037 52.7429 59.5037 47.2571 56.1201 43.8735C52.7366 40.49 47.2507 40.49 43.8672 43.8735C40.4836 47.2571 40.4836 52.7429 43.8672 56.1265C47.2507 59.51 52.7366 59.51 56.1201 56.1265Z" fill="#FDCD56" />
                                                                                <path d="M55.1719 55.1782C58.0317 52.3184 58.0317 47.6816 55.1719 44.8218C52.312 41.9619 47.6753 41.9619 44.8154 44.8218C41.9556 47.6816 41.9556 52.3184 44.8154 55.1782C47.6753 58.0381 52.312 58.0381 55.1719 55.1782Z" fill="#F5B945" />
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M50.0026 49.215C49.2803 49.215 48.6902 48.7297 48.6902 48.1322C48.6902 47.5356 49.2803 47.0504 50.0026 47.0504C50.3721 47.0504 51.0779 47.3704 51.2047 47.5589C51.4528 47.9387 51.9657 48.0442 52.3406 47.7946C52.7211 47.546 52.8259 47.0374 52.5777 46.659C52.2137 46.1047 51.4693 45.7217 50.8076 45.5364L50.7966 45.0371C50.7855 44.5919 50.4216 44.2368 49.975 44.2368C49.9695 44.2368 49.9639 44.2368 49.9584 44.2368C49.5007 44.2484 49.1423 44.6235 49.1534 45.0769L49.1644 45.521C47.9457 45.854 47.0469 46.8981 47.0469 48.1321C47.0469 49.6343 48.3758 50.8554 50.0026 50.8554C50.725 50.8554 51.3095 51.3404 51.3095 51.9372C51.3095 52.5347 50.725 53.02 50.0026 53.02C49.4953 53.02 49.2526 52.8712 48.784 52.4257C48.4532 52.1153 47.9347 52.1294 47.6204 52.4597C47.3116 52.7891 47.3282 53.3083 47.6535 53.6188C48.067 54.0079 48.5248 54.3897 49.1974 54.5633L49.2029 54.9629C49.2139 55.4095 49.5834 55.7635 50.0245 55.7635H50.0466C50.4988 55.7516 50.8571 55.3765 50.8461 54.9231L50.8351 54.5492C52.0593 54.2153 52.9526 53.171 52.9526 51.9372C52.9528 50.4359 51.6294 49.215 50.0026 49.215ZM74.2765 46.4762C74.2765 46.4258 74.2324 46.3825 74.1827 46.3825H58.7703C58.9689 46.8665 59.1288 47.3717 59.2501 47.8907H74.2765V46.4762ZM77.2102 49.5312H59.4762C59.4817 49.6872 59.4872 49.843 59.4872 50.0002C59.4872 50.3517 59.4652 50.6985 59.4265 51.0408H77.21C77.2652 51.0408 77.3038 50.9973 77.3038 50.9471V49.6262C77.3039 49.5748 77.2652 49.5312 77.2102 49.5312ZM57.844 50.0002C57.844 54.3255 54.3259 57.8447 50.0026 57.8447C45.6739 57.8447 42.1559 54.3255 42.1559 50.0002C42.1559 45.6747 45.6739 42.1556 50.0026 42.1556C54.3259 42.1556 57.844 45.6747 57.844 50.0002ZM46.082 64.542C46.082 62.5426 46.1427 60.5857 46.253 58.7129C46.242 58.7083 46.2309 58.7037 46.2199 58.6989H44.5325C44.6428 60.574 44.7035 62.5343 44.7035 64.5419C44.7035 66.7753 44.6318 68.9458 44.494 71.0058H46.2916C46.1537 68.9459 46.082 66.7755 46.082 64.542ZM48.012 72.7403C48.012 72.6899 47.9679 72.6465 47.9182 72.6465H25.817C25.7673 72.6465 25.7232 72.6899 25.7232 72.7403V74.1559H48.012V72.7403ZM50.9456 75.7964H22.7897C22.74 75.7964 22.6959 75.8386 22.6959 75.8904V77.211C22.6959 77.2614 22.74 77.3047 22.7897 77.3047H50.9456C50.9952 77.3047 51.0394 77.2615 51.0394 77.211V75.8904C51.0394 75.8387 50.9952 75.7964 50.9456 75.7964ZM27.4823 58.6989C27.5926 60.574 27.6533 62.5343 27.6533 64.5419C27.6533 66.7753 27.5816 68.9458 27.4438 71.0058H29.247C29.1035 68.9456 29.0374 66.7753 29.0374 64.5419C29.0374 62.5343 29.0926 60.574 29.2084 58.6989H27.4823ZM36.1784 64.542C36.1784 66.7755 36.1066 68.9459 35.9688 71.0059H37.772C37.6286 68.9458 37.5625 66.7755 37.5625 64.542C37.5625 62.5368 37.6175 60.5751 37.7334 58.699H36.0075C36.1177 60.574 36.1784 62.5344 36.1784 64.542ZM34.32 71.0059C34.4633 68.9493 34.535 66.7791 34.535 64.542C34.535 62.5321 34.48 60.5717 34.3641 58.699H30.8516C30.7358 60.5718 30.6751 62.5321 30.6751 64.542C30.6751 66.7791 30.7468 68.9493 30.8902 71.0059H34.32ZM42.8892 58.6989H39.3711C39.2609 60.5726 39.2002 62.5343 39.2002 64.5419C39.2002 66.779 39.2719 68.9492 39.4152 71.0058H42.845C42.9884 68.9492 43.0601 66.779 43.0601 64.5419C43.0602 62.5321 43.0051 60.5717 42.8892 58.6989ZM22.6959 57.0583H43.6723C43.176 56.6107 42.7238 56.1127 42.3323 55.5712H22.6959V57.0583ZM28.122 53.9306H41.3728C40.9703 53.0529 40.7 52.1059 40.5843 51.1124L36.9007 49.0769L28.122 53.9306ZM53.9177 38.2767C53.9177 39.3055 53.9012 40.3344 53.8737 41.3434C54.3975 41.5801 54.9048 41.8638 55.3736 42.1895C55.324 40.9111 55.3018 39.6021 55.3018 38.2767C55.3018 36.2715 55.3569 34.311 55.4728 32.4338H53.7469C53.8627 34.311 53.9177 36.2715 53.9177 38.2767ZM48.9605 30.793H77.3039V29.3059H48.9605V30.793ZM54.3865 27.6654H71.944L63.1652 22.8128L54.3865 27.6654ZM70.9679 38.2767C70.9679 40.5115 70.8962 42.6806 70.7529 44.7419H72.556C72.4182 42.6817 72.3465 40.5115 72.3465 38.2767C72.3465 36.2715 72.4072 34.3099 72.5175 32.4338H70.7971C70.9073 34.3099 70.9679 36.2715 70.9679 38.2767ZM69.1097 44.7419C69.253 42.6853 69.3247 40.5149 69.3247 38.2767C69.3247 36.2692 69.2696 34.3076 69.1537 32.4338H65.6357C65.5254 34.3076 65.4647 36.2692 65.4647 38.2767C65.4647 40.515 65.5364 42.6853 65.6797 44.7419H69.1097ZM62.4429 38.2767C62.4429 40.5115 62.3712 42.6817 62.2334 44.7419H64.0365C63.8932 42.6817 63.8215 40.5115 63.8215 38.2767C63.8215 36.2715 63.8822 34.311 63.9925 32.4338H62.272C62.3822 34.311 62.4429 36.2715 62.4429 38.2767ZM57.888 44.7419H60.5845C60.7278 42.6853 60.7996 40.5149 60.7996 38.2767C60.7996 36.2692 60.7445 34.3076 60.6286 32.4338H57.116C57.0002 34.3076 56.9395 36.2692 56.9395 38.2767C56.9395 40.1329 56.9892 41.9575 57.0885 43.7072C57.3807 44.0329 57.6455 44.3787 57.888 44.7419ZM73.9897 38.2767C73.9897 40.5161 74.0614 42.6865 74.2048 44.7431C75.1477 44.7547 75.9142 45.5272 75.9142 46.4762V47.8908H77.21C78.1696 47.8908 78.947 48.6688 78.947 49.6263V50.9472C78.947 51.9034 78.1694 52.6814 77.21 52.6814H59.0958C57.9377 56.6097 54.2984 59.4853 50.0027 59.4853C49.2694 59.4853 48.5524 59.3998 47.8687 59.2404C47.775 60.9503 47.7254 62.7279 47.7254 64.5421C47.7254 66.7792 47.7971 68.9507 47.9405 71.0073C48.8834 71.0189 49.6499 71.7912 49.6499 72.7404V74.156H50.9457C51.9053 74.156 52.6827 74.934 52.6827 75.8904V77.211C52.6827 78.1674 51.9052 78.9455 50.9457 78.9455H22.7897C21.8357 78.9455 21.0527 78.1675 21.0527 77.211V75.8904C21.0527 74.934 21.8358 74.156 22.7897 74.156H24.0855V72.7404C24.0855 71.7924 24.8521 71.0189 25.795 71.0073C25.9383 68.9507 26.01 66.7792 26.01 64.5421C26.01 62.5322 25.9548 60.5718 25.839 58.6991H22.6684C21.7806 58.6991 21.0527 57.9749 21.0527 57.0866V55.5433C21.0527 54.6539 21.7806 53.9308 22.6684 53.9308H24.7308L36.5038 47.4222C36.752 47.2849 37.0496 47.2849 37.2978 47.4222L40.5513 49.2197C40.9484 44.3529 45.0345 40.515 50.0028 40.515C50.7749 40.515 51.5248 40.6101 52.2471 40.7858C52.2636 39.9562 52.2746 39.117 52.2746 38.2769C52.2746 36.2693 52.2196 34.3077 52.1037 32.4339H48.9329C48.0451 32.4339 47.3228 31.7108 47.3228 30.8214V29.278C47.3228 28.3897 48.0451 27.6655 48.9329 27.6655H50.9953L62.7682 21.1568C63.0163 21.0206 63.3141 21.0206 63.5623 21.1568L75.3353 27.6653H77.3314C78.2248 27.6653 78.9471 28.3895 78.9471 29.2778V30.8212C78.9471 31.7106 78.2248 32.4337 77.3314 32.4337H74.1607C74.0449 34.3075 73.9897 36.2692 73.9897 38.2767ZM71.3926 58.542C71.2382 58.3883 71.0286 58.3019 70.8081 58.3019C70.593 58.3019 70.3835 58.3885 70.2291 58.542L66.7495 62.0211C66.4297 62.3424 66.4297 62.8614 66.7495 63.1813C67.0693 63.5024 67.5877 63.5024 67.9131 63.1813L69.992 61.1024V66.3663C69.992 68.2345 68.4701 69.7531 66.6062 69.7531H60.2759C59.8181 69.7531 59.4543 70.1199 59.4543 70.5735C59.4543 71.0258 59.8182 71.3937 60.2759 71.3937H66.6062C69.3744 71.3937 71.6297 69.1391 71.6297 66.3662V61.1024L73.7086 63.1813C74.0284 63.5024 74.5522 63.5024 74.8721 63.1813C75.192 62.8614 75.192 62.3424 74.8721 62.0211L71.3926 58.542ZM25.1333 37.9791L28.6129 41.4585C28.7728 41.6189 28.9823 41.6986 29.1919 41.6986C29.4014 41.6986 29.6109 41.6189 29.7709 41.4585L33.2504 37.9791C33.5702 37.658 33.5702 37.1388 33.2504 36.8189C32.9306 36.4978 32.4123 36.4978 32.0924 36.8189L30.0135 38.8978V33.6338C30.0135 31.7658 31.5299 30.2471 33.3993 30.2471H39.7296C40.1818 30.2471 40.5457 29.8803 40.5457 29.4269C40.5457 28.9745 40.1817 28.6063 39.7296 28.6063H33.3991C30.6254 28.6063 28.3702 30.8612 28.3702 33.6338V38.8978L26.2912 36.8189C25.9714 36.4978 25.4531 36.4978 25.1332 36.8189C24.8134 37.1387 24.8134 37.6579 25.1333 37.9791Z" fill="black" />
                                                                            </g>
                                                                            <defs>
                                                                                <clipPath id="clip0_1314_21405">
                                                                                    <rect width="100" height="100" fill="white" />
                                                                                </clipPath>
                                                                            </defs>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                                <div className="labelBankS">Bank Sync</div>
                                                                <div className="infoText">
                                                                    When enabled, Bank Sync automatically imports transactions from your connected bank account and finds matches with Inn-Flow transactions.
                                                                    This makes keeping up with your daily accounting easy and makes reconciliation a snap.
                                                                </div>
                                                                <div className="btn-BankSync">
                                                                    <Button
                                                                        variant="primary"
                                                                        type="button"
                                                                        className="btn btn-primary"
                                                                        onClick={() => this.changeBankSyncOn(true)}
                                                                    >
                                                                        Enable Bank Sync
                                                                    </Button>
                                                                </div>
                                                            </>
                                                        )}
                                                        {this.state.bankSyncOn && (
                                                            <SetupBankSync
                                                                parentState={this.state}
                                                                handleCancelSetup={this.handleCancelSetup}
                                                                callBackBankSetup={this.callBackBankSetup}
                                                                OprID={this.props.oprID}
                                                                accountName={this.state?.connectedAcctName}
                                                                closeSlideoutReconnect={this.closeSlideoutReconnect}
                                                                callFrom={this.props?.callFrom}
                                                                bankNickName={this.state.formData.displayName}
                                                            ></SetupBankSync>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                )} */}
                            </Tabs>

                        </div>
                        {this.state.isDiscardChanges && (
                            <div className="footer-section d-flex justify-content-end align-items-center">
                                <Button variant="primary" type="button" className="space btn btn-primary btn-discard" onClick={() => { this.pageClose(0) }}>
                                    Discard
                                </Button>
                                <Button type="button" className="btn btn-primary" onClick={() => { this.saveCardDetails() }}>Save</Button>
                            </div>
                        )}

                    </Container>
                    {this.state.isSpinner && (
                        <div className="loader-spinner d-flex justify-content-center align-items-center">
                            <Spinner animation="border" variant="success" />
                        </div>
                    )}
                </div>
            </div>
        )
    }
    changeBankSyncOn = (checked) => {
        if (!this.state.isBankSyncDone && this.state?.plaidConnectionStatus?.toLowerCase() !== "reconnect")
            this.setState({ bankSyncOn: checked });
    }
    handleCancelSetup = () => {
        this.setState({ bankSyncOn: false })
    }
    callBackBankSetup = (status) => {
        this.setState({ isBankSyncDone: status, isPlaidDone: true, isPlaidProcessComplete: true  }, () => {
            this.PlaidSetupDetails();
        });
    }
    closeSlideoutReconnect = () => {
        this.pageClose(3);
    }
}